import WillEditorCheckboxes from "../components/checkboxes";
import STKAnimated from "@/components/common/animated";
import { fieldLabels, viewHeadings } from "../will-editor";
import { PageContentField } from "@/providers/content-provider";
const WillEditorView3 = () => {


    return(
        <STKAnimated key={3} type="down-to-up">
            <h4>2. {viewHeadings[2]}</h4>
            <PageContentField section={'view-3'} index={0} />
            <div className="mt-4">
                <h6>{fieldLabels.how?.value}</h6> 
                <WillEditorCheckboxes name="how" checkboxes={[
                    {
                        value: 'Kirkkomaa',
                        subField: fieldLabels.how?.subField
                    },
                    {
                        value: 'Tuhkaus',
                    },
                    {
                        value: 'Omaiset saavat päättää',
                    },
                ]} />
            </div>
        </STKAnimated>
    );

}

export default WillEditorView3;